import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/skins.css";
import { applySkin, resolveAppearance } from "./lib/skins";
import { applyCustomization, getCustomization } from "./lib/customizer";
import { IS_DEMO, withPersonaLook } from "./lib/demo";
import { CREATOR_LOOK } from "./lib/creator";

// Paint the creator's skin before the first render (no flash of the default theme).
// The demo layers the persona's look and the visitor's local customization (sessionStorage) on top;
// the real build paints the creator's fixed look (src/config/creator.json).
const overrides = IS_DEMO ? withPersonaLook(getCustomization()) : CREATOR_LOOK;
const firstSkin = resolveAppearance(undefined, overrides).skin;
applySkin(firstSkin);
applyCustomization(overrides, firstSkin.scheme === "dark");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
